module.exports = __webpack_public_path__ + "05_mole.b2933509.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/05_mole.png
// module id = Utpk
// module chunks = 0